export const getBackofficeBaseUrl = () => '/api/v1';
